<template>
  <section class="content">
    <template v-for="alert in alerts">
      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
        <h4>
          <i v-if="alert.type == 'success' || alert.type == 'warning'" class="icon fa fa-check"></i>
          <i class="icon fa fa-ban" v-else></i>
          {{'alert_'+alert.type | translate}}!</h4>
        <p v-if="alert.type !== 'danger'">
          {{alert.message}}
        </p>
        <ul v-else>
          <li v-for="e in alert.message">
            {{e}}
          </li>
        </ul>
      </b-alert>
    </template>
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">{{'top-seller-stats' | translate}}</h3>
        </div>
        <div class="box-controls">
          <multiselect
            v-model="company"
            :options="companies"
            :placeholder="'select_one' | translate"
            label="name"
            track-by="id"
            @input="getData()"
          >
          </multiselect>
        </div>
        <div v-if="company.id === 0" class="box-body">
          <div class="callout callout-info">
            <h4><i class="fa fa-exclamation-triangle mr-5"></i>Info</h4>
            <p>{{ 'no_top_seller_existing_chose_company' | translate }}</p>
          </div>
        </div>
        <div class="box-body" v-else>
          <h3><i class="fa fa-id-badge mr-5"></i>{{ 'merchant' | translate }}</h3>
          <div class="row pt-10">
            <div class="col-xs-12">
               <div class="overlay" v-if="loadingMerchant">
                <img class="loading-gif" src="/static/img/blabla.svg"/>
              </div>
              <div class="nav-tabs-custom" v-else>
                <ul class="nav nav-tabs">
                  <li class="active">
                    <a href="#tab_2-1" data-toggle="tab" aria-expanded="true">
                      <i class="fa fa-trophy mr-5"></i>{{ 'total' | translate }}
                    </a>
                  </li>
                  <li>
                    <a href="#tab_2-2" data-toggle="tab" aria-expanded="false">
                      <i class="fa fa-mars mr-5"></i>{{'men' | translate}}
                    </a>
                  </li>
                  <li>
                    <a href="#tab_2-3" data-toggle="tab" aria-expanded="false">
                      <i class="fa fa-venus mr-5"></i>{{'women' | translate}}
                    </a>
                  </li>
                  <li>
                    <a href="#tab_2-4" data-toggle="tab" aria-expanded="false">
                      <i class="fa fa-transgender mr-5"></i>{{'kids' | translate}}
                    </a>
                  </li>
                </ul>
                <div class="tab-content">
                  <div id="tab_2-1" class="tab-pane active">
                    <div v-if="merchantTotal && merchantTotal.length > 0" class="table-responsive">
                      <table class="table table-hover">
                        <thead>
                        <tr>
                          <th style="width:5%">{{'ranking' | translate}}</th>
                          <th style="width:8%">{{'ranking_global' | translate}}</th>
                          <th style="width:8%">{{'previous_rank' | translate}}</th>
                          <th>{{'image' | translate}}</th>
                          <th>{{'title' | translate}}</th>
                          <th>{{'brand' | translate}}</th>
                          <th>{{'product_info' | translate}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in merchantTotal">
                          <td><span v-html="getCellData(item)"></span></td>
                          <td><span v-html="getGlobalData(item)"></span></td>
                          <td v-if="item.rank_prev !== 0">{{item.rank_prev}}</td>
                          <td v-else><i class="fa fa-minus"></i></td>
                          <td>
                            <router-link :to="'/products/'+ item.wws_model">
                              <img :src="item.img_path" class="img-preview">
                            </router-link>
                          </td>
                          <td>
                            <router-link :to="'/products/'+ item.wws_model">
                              <strong>{{item.title}}</strong>
                            </router-link>
                          </td>
                          <td>{{item.brand}}</td>
                          <td style="width:20%">
                            <small class="text-muted">{{'erp_id' | translate}}: {{item.wws_number}}</small><br>
                            <small class="text-muted">{{'erp_number' | translate}}: {{item.wws_model}}</small>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else>
                      <div class="callout callout-info">
                        <h4><i class="fa fa-exclamation-triangle mr-5"></i>{{ 'info' | translate }}</h4>
                        <p>{{ 'no_top20_in_range' | translate }}</p>
                      </div>
                    </div>
                  </div>
                  <div id="tab_2-2" class="tab-pane">
                    <div v-if="merchantMen && merchantMen.length > 0" class="table-responsive">
                      <table class="table table-hover">
                        <thead>
                        <tr>
                          <th style="width:5%">{{'ranking' | translate}}</th>
                          <th style="width:8%">{{'ranking_global' | translate}}</th>
                          <th style="width:8%">{{'previous_rank' | translate}}</th>
                          <th>{{'image' | translate}}</th>
                          <th>{{'title' | translate}}</th>
                          <th>{{'brand' | translate}}</th>
                          <th>{{'product_info' | translate}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in merchantMen">
                          <td><span v-html="getCellData(item)"></span></td>
                          <td><span v-html="getGlobalData(item)"></span></td>
                          <td v-if="item.rank_prev !== 0">{{item.rank_prev}}</td>
                          <td v-else><i class="fa fa-minus"></i></td>
                          <td>
                            <router-link :to="'/products/'+ item.wws_model">
                              <img :src="item.img_path" class="img-preview">
                            </router-link>
                          </td>
                          <td>
                            <router-link :to="'/products/'+ item.wws_model">
                              <strong>{{item.title}}</strong>
                            </router-link>
                          </td>
                          <td>{{item.brand}}</td>
                          <td style="width:20%">
                            <small class="text-muted">{{'erp_id' | translate}}: {{item.wws_number}}</small><br>
                            <small class="text-muted">{{'erp_number' | translate}}: {{item.wws_model}}</small>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else>
                      <div class="callout callout-info">
                        <h4><i class="fa fa-exclamation-triangle mr-5"></i>{{ 'info' | translate }}</h4>
                        <p>{{ 'no_top20_in_range' | translate }}</p>
                      </div>
                    </div>
                  </div>
                  <div id="tab_2-3" class="tab-pane">
                    <div v-if="merchantWomen && merchantWomen.length > 0" class="table-responsive">
                      <table class="table table-hover">
                        <thead>
                        <tr>
                          <th style="width:5%">{{'ranking' | translate}}</th>
                          <th style="width:8%">{{'ranking_global' | translate}}</th>
                          <th style="width:8%">{{'previous_rank' | translate}}</th>
                          <th>{{'image' | translate}}</th>
                          <th>{{'title' | translate}}</th>
                          <th>{{'brand' | translate}}</th>
                          <th>{{'product_info' | translate}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in merchantWomen">
                          <td><span v-html="getCellData(item)"></span></td>
                          <td><span v-html="getGlobalData(item)"></span></td>
                          <td v-if="item.rank_prev !== 0">{{item.rank_prev}}</td>
                          <td v-else><i class="fa fa-minus"></i></td>
                          <td>
                            <router-link :to="'/products/'+ item.wws_model">
                              <img :src="item.img_path" class="img-preview">
                            </router-link>
                          </td>
                          <td>
                            <router-link :to="'/products/'+ item.wws_model">
                              <strong>{{item.title}}</strong>
                            </router-link>
                          </td>
                          <td>{{item.brand}}.</td>
                          <td style="width:20%">
                            <small class="text-muted">{{'erp_id' | translate}}: {{item.wws_number}}</small><br>
                            <small class="text-muted">{{'erp_number' | translate}}: {{item.wws_model}}</small>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else>
                      <div class="callout callout-info">
                        <h4><i class="fa fa-exclamation-triangle mr-5"></i>{{ 'info' | translate }}</h4>
                        <p>{{ 'no_top20_in_range' | translate }}</p>
                      </div>
                    </div>
                  </div>
                  <div id="tab_2-4" class="tab-pane">
                    <div v-if="merchantKids && merchantKids.length > 0" class="table-responsive">
                      <table class="table table-hover">
                        <thead>
                        <tr>
                          <th style="width:5%">{{'ranking' | translate}}</th>
                          <th style="width:8%">{{'ranking_global' | translate}}</th>
                          <th style="width:8%">{{'previous_rank' | translate}}</th>
                          <th>{{'image' | translate}}</th>
                          <th>{{'title' | translate}}</th>
                          <th>{{'brand' | translate}}</th>
                          <th>{{'product_info' | translate}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in merchantKids">
                          <td><span v-html="getCellData(item)"></span></td>
                          <td><span v-html="getGlobalData(item)"></span></td>
                          <td v-if="item.rank_prev !== 0">{{item.rank_prev}}</td>
                          <td v-else><i class="fa fa-minus"></i></td>
                          <td>
                            <router-link :to="'/products/'+ item.wws_model">
                              <img :src="item.img_path" class="img-preview">
                            </router-link>
                          </td>
                          <td>
                            <router-link :to="'/products/'+ item.wws_model">
                              <strong>{{item.title}}</strong>
                            </router-link>
                          </td>
                          <td>{{item.brand}}</td>
                          <td style="width:20%">
                            <small class="text-muted">{{'erp_id' | translate}}: {{item.wws_number}}</small><br>
                            <small class="text-muted">{{'erp_number' | translate}}: {{item.wws_model}}</small>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else>
                      <div class="callout callout-info">
                        <h4><i class="fa fa-exclamation-triangle mr-5"></i>{{ 'info' | translate }}</h4>
                        <p>{{ 'no_top20_in_range' | translate }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <h3><i class="fa fa-globe mr-5"></i>Global</h3>
          <div class="row pt-10">
            <div class="col-xs-12">
              <div class="overlay" v-if="loadingGlobal">
                <img class="loading-gif" src="/static/img/blabla.svg"/>
              </div>
              <div class="nav-tabs-custom" v-else>
                <ul class="nav nav-tabs">
                  <li class="active">
                    <a href="#tab_1-1" data-toggle="tab" aria-expanded="true">
                      <i class="fa fa-trophy mr-5"></i>{{ 'total' | translate }}
                    </a>
                  </li>
                  <li>
                    <a href="#tab_1-2" data-toggle="tab" aria-expanded="false">
                      <i class="fa fa-mars mr-5"></i>{{'men' | translate}}
                    </a>
                  </li>
                  <li>
                    <a href="#tab_1-3" data-toggle="tab" aria-expanded="false">
                      <i class="fa fa-venus mr-5"></i>{{'women' | translate}}
                    </a>
                  </li>
                  <li>
                    <a href="#tab_1-4" data-toggle="tab" aria-expanded="false">
                      <i class="fa fa-transgender mr-5"></i>{{'kids' | translate}}
                    </a>
                  </li>
                </ul>
                <div class="tab-content">
                  <div id="tab_1-1" class="tab-pane active">
                    <div v-if="globalTotal && globalTotal.length > 0" class="table-responsive">
                      <table class="table table-hover">
                        <thead>
                        <tr>
                          <th style="width:8%">{{'ranking' | translate}}</th>
                          <th style="width:8%">{{'previous_rank' | translate}}</th>
                          <th>{{'image' | translate}}</th>
                          <th>{{'title' | translate}}</th>
                          <th>{{'brand' | translate}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in globalTotal">
                          <td><span v-html="getCellData(item)"></span></td>
                          <td v-if="item.rank_prev !== 0">{{item.rank_prev}}</td>
                          <td v-else><i class="fa fa-minus"></i></td>
                          <td>
                            <router-link :to="'/products/'+ item.wws_model">
                              <img :src="item.img_path" class="img-preview">
                            </router-link>
                          </td>
                          <td>
                            <router-link :to="'/products/'+ item.wws_model">
                              <strong>{{item.title}}</strong>
                            </router-link>
                          </td>
                          <td>{{item.brand}}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else>
                      <div class="callout callout-info">
                        <h4><i class="fa fa-exclamation-triangle mr-5"></i>{{ 'info' | translate }}</h4>
                        <p>{{ 'no_top20_in_range' | translate }}</p>
                      </div>
                    </div>
                  </div>
                  <div id="tab_1-2" class="tab-pane">
                    <div v-if="globalMen && globalMen.length > 0" class="table-responsive">
                      <table class="table table-hover">
                        <thead>
                        <tr>
                          <th style="width:8%">{{'ranking' | translate}}</th>
                          <th style="width:8%">{{'previous_rank' | translate}}</th>
                          <th>{{'image' | translate}}</th>
                          <th>{{'title' | translate}}</th>
                          <th>{{'brand' | translate}}</th>
                          <th>{{'product_info' | translate}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in globalMen">
                          <td><span v-html="getCellData(item)"></span></td>
                          <td v-if="item.rank_prev !== 0">{{item.rank_prev}}</td>
                          <td v-else><i class="fa fa-minus"></i></td>
                          <td>
                            <router-link :to="'/products/'+ item.wws_model">
                              <img :src="item.img_path" class="img-preview">
                            </router-link>
                          </td>
                          <td>
                            <router-link :to="'/products/'+ item.wws_model">
                              <strong>{{item.title}}</strong>
                            </router-link>
                          </td>
                          <td>{{item.brand}}</td>
                          <td style="width:20%">
                            <small class="text-muted">{{'erp_id' | translate}}: {{item.wws_number}}</small><br>
                            <small class="text-muted">{{'erp_number' | translate}}: {{item.wws_model}}</small>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else>
                      <div class="callout callout-info">
                        <h4><i class="fa fa-exclamation-triangle mr-5"></i>{{ 'info' | translate }}</h4>
                        <p>{{ 'no_top20_in_range' | translate }}</p>
                      </div>
                    </div>
                  </div>
                  <div id="tab_1-3" class="tab-pane">
                    <div v-if="globalWomen && globalWomen.length > 0" class="table-responsive">
                      <table class="table table-hover">
                        <thead>
                        <tr>
                          <th style="width:8%">{{'ranking' | translate}}</th>
                          <th style="width:8%">{{'previous_rank' | translate}}</th>
                          <th>{{'image' | translate}}</th>
                          <th>{{'title' | translate}}</th>
                          <th>{{'brand' | translate}}</th>
                          <th>{{'product_info' | translate}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in globalWomen" :key="item.rank">
                          <td><span v-html="getCellData(item)"></span></td>
                          <td v-if="item.rank_prev !== 0">{{item.rank_prev}}</td>
                          <td v-else><i class="fa fa-minus"></i></td>
                          <td>
                            <router-link :to="'/products/'+ item.wws_model">
                              <img :src="item.img_path" class="img-preview">
                            </router-link>
                          </td>
                          <td>
                            <router-link :to="'/products/'+ item.wws_model">
                              <strong>{{item.title}}</strong>
                            </router-link>
                          </td>
                          <td>{{item.brand}}</td>
                          <td style="width:20%">
                            <small class="text-muted">{{'erp_id' | translate}}: {{item.wws_number}}</small><br>
                            <small class="text-muted">{{'erp_number' | translate}}: {{item.wws_model}}</small>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else>
                      <div class="callout callout-info">
                        <h4><i class="fa fa-exclamation-triangle mr-5"></i>{{ 'info' | translate }}</h4>
                        <p>{{ 'no_top20_in_range' | translate }}</p>
                      </div>
                    </div>
                  </div>
                  <div id="tab_1-4" class="tab-pane">
                    <div v-if="globalKids && globalKids.length > 0" class="table-responsive">
                      <table class="table table-hover">
                        <thead>
                        <tr>
                          <th style="width:8%">{{'ranking' | translate}}</th>
                          <th style="width:8%">{{'previous_rank' | translate}}</th>
                          <th>{{'image' | translate}}</th>
                          <th>{{'title' | translate}}</th>
                          <th>{{'brand' | translate}}</th>
                          <th>{{'product_info' | translate}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in globalKids" :key="item.rank">
                          <td><span v-html="getCellData(item)"></span></td>
                          <td v-if="item.rank_prev !== 0">{{item.rank_prev}}</td>
                          <td v-else><i class="fa fa-minus"></i></td>
                          <td>
                            <router-link :to="'/products/'+ item.wws_model"><img :src="item.img_path" class="img-preview"/></router-link>
                          </td>
                          <td><router-link :to="'/products/'+ item.wws_model"><strong>{{item.title}}</strong></router-link></td>
                          <td>{{item.brand}}</td>
                          <td style="width:20%">
                            <small class="text-muted">{{'erp_id' | translate}}: {{item.wws_number}}</small><br>
                            <small class="text-muted">{{'erp_number' | translate}}: {{item.wws_model}}</small>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else>
                      <div class="callout callout-info">
                        <h4><i class="fa fa-exclamation-triangle mr-5"></i>{{ 'info' | translate }}</h4>
                        <p>{{ 'no_top20_in_range' | translate }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box-footer" v-if="company.id !== 0">
          <div class="row">
            <div class="col-xs-12">
              <h5>{{'legend' | translate}}: </h5>
              <div class="small">
                <span class="mr-5"><i class="fa fa-minus"></i> = {{'same_before' | translate}}</span>
                <span class="mr-5"><i class="fa fa-arrow-up text-success"></i> = {{'better_than_before' | translate}}</span>
                <span class="mr-5"><i class="fa fa-arrow-down text-danger"></i> = {{'worse_than_before' | translate}}</span>
                <span class="mr-5"><i class="fa fa-star text-primary"></i> = {{'new_item_top' | translate}}</span><br/>
                <hr>
                <span class="mr-5"><img class="logo-mini" style="width: 10%" src="/static/img/conventa.png"/></span>
              </div>
            </div>
          </div>
        </div>
      </div>
  </section>
</template>

<script>

import VueMultiselect from 'vue-multiselect/src/Multiselect'
export default {
  name: 'Statistics',
  components: {VueMultiselect},
  data () {
    return {
      companies: [],
      company: {
        id: 0,
        name: 'Wählen Sie ein Unternehmen aus'
      },
      loadingGlobal: true,
      loadingMerchant: true,
      sortReturnRate: '',
      sortPriceRate: '',
      alerts: [],
      globalTotal: [],
      globalMen: [],
      globalWomen: [],
      globalKids: [],
      merchantTotal: [],
      merchantWomen: [],
      merchantMen: [],
      merchantKids: []
    }
  },
  computed: {
  },
  methods: {
    getIcon (mp) {
      return mp === 'schuhede' ? 'fa-schuhe' : 'fa-' + mp
    },
    getCellData (item) {
      if (item.rank_prev === 0) {
        return '<i class="fa fa-star mr-5 text-primary"></i><span class="text-primary">' + item.rank + '</span>'
      } else if (item.rank_prev === item.rank) {
        return '<i class="fa fa-minus mr-5"></i><span>' + item.rank + '</span>'
      } else if (item.rank - item.rank_prev < 0) {
        return '<i class="fa fa-arrow-up text-success mr-5"></i><span class="text-success">' + item.rank + '</span>'
      } else {
        return '<i class="fa fa-arrow-down text-danger mr-5"></i><span class="text-danger">' + item.rank + '</span>'
      }
    },
    getGlobalData (item) {
      if (item.rank_global_prev === 0) {
        return '<i class="fa fa-star mr-5 text-primary"></i><span class="text-primary">' + item.rank_global + '</span>'
      } else if (item.rank_global_prev === item.rank_global) {
        return '<i class="fa fa-minus mr-5"></i><span>' + item.rank_global + '</span>'
      } else if (item.rank_global - item.rank_global_prev < 0) {
        return '<i class="fa fa-arrow-up text-success mr-5"></i><span class="text-success">' + item.rank_global + '</span>'
      } else {
        return '<i class="fa fa-arrow-down text-danger mr-5"></i><span class="text-danger">' + item.rank_global + '</span>'
      }
    },
    getData () {
      API.get(`statistics/top-seller/merchant/${this.company.id}`)
        .then(res => {
          this.merchantTotal = res.data.total
          this.merchantMen = res.data.men
          this.merchantWomen = res.data.women
          this.merchantKids = res.data.kids
          this.loadingMerchant = false
        })
        .catch(error => {
          this.loadingMerchant = false
          console.log(error)
        })
      API.get('statistics/top-seller/global')
        .then(res => {
          this.globalTotal = res.data.total
          this.globalMen = res.data.men
          this.globalWomen = res.data.women
          this.globalKids = res.data.kids
          this.loadingGlobal = false
        })
        .catch(error => {
          this.loadingGlobal = false
        })
    }
  },
  mounted () {
    this.companies = this.$store.getters.companies
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .is-clickable {
    cursor: pointer;
  }
  .multiselect, .multiselect__input, .multiselect__single {
    font-size: 14px !important;
    background: transparent !important;
    color: #ffffff !important;
  }
  .multiselect__spinner {
    background: #212228 !important;
  }
  .multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 8px 40px 0 8px;
    border-radius: 0px !important;
    border: 1px solid rgba(255,255,255,.15);
    color: #ffffff;
    background: transparent !important;
    font-size: 14px;
  }
  .multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #212228;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid rgba(255,255,255,.15);
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 1;
    -webkit-overflow-scrolling: touch;
  }
</style>
<style scoped>
  .alert.alert-message {
    position: fixed;
  }
  .alert-dismissible {
    z-index: 9999;
    position: fixed;
    width: 300px;
    top: 60px;
    right: 20px;
  }
</style>
<style scoped>
    .loading-gif {
        display: block;
        width: 5%;
        top: 42%;
        left: 45%;
        position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/Statistics/TopSeller.vue